import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_01.png"
import Img_Two from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_02.png"
import Img_Three from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_03.png"
import Img_Four from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_04.png"
import Img_Five from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_05.png"
import Img_Six from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_06.png"
import Img_Seven from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_07.png"
import Img_Eight from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_08.png"
import Img_Nine from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_09.png"
import Img_Ten from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_10.png"
import Img_Eleven from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_11.png"
import Img_Twelve from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_12.png"
import Img_Thirteen from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_13.png"
import Img_Fourteen from "./../../../../sources/imgs/JOHNTHERIPPER/JOHN_14.png"

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function JOHNTHERIPPER (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink">JOHN THE RIPPER.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a John the Ripper.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">John the Ripper</span> <span className="span-white">(JtR)</span> es una <span className="span-pink">herramienta</span> de software <spab className="span-white">gratuita</spab> para <span className="span-blue">auditar</span> y <span className="span-blue">descifrar contraseñas</span>. Es muy utilizada en <span className="span-white">ciberseguridad</span> y <span className="span-white">pruebas de penetración</span> para <span className="span-pink">comprobar la seguridad</span> de las <span className="span-white">contraseñas almacenadas en hashes</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Instalación de John the Ripper.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                La mayoría de <span className="span-pink">versiones</span> de <span className="span-pink">Kali Linux</span> ya incluyen una versión básica de <span className="span-white">John</span>.
            </p>

            <p>
                Para <span className="span-pink">verificarlo</span>, puedes utilizar el <span className="span-white">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "john"
            />

            <p>
                <span className="span-pink">Visualizando</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"1. Comando principal de John the Ripper."}
            />

            <p>
                <span className="span-yellow">
                    Nota:
                </span> Si ves una <span className="span-pink">versión</span> como <i className="span-white">John the Ripper 1.9.x</i>, ya lo tienes.
            </p>

            <p>
                Si no cuentas son él, puedes <span className="span-pink">instalarlo</span>, utilizando:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt update"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install john -y"
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Documentación de John the Ripper.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si deseamos <span className="span-white">visualizar</span> la <span className="span-pink">información util</span> de la <span className="span-pink">herramienta</span>, podemos ejecutar el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "john --help"
            />

            <p>
                <span className="span-yellow">Nota:</span> Este comando nos deplegará la <span className="span-white">documentación</span> sobre el uso de la <span className="span-pink">herramienta</span>, tales como <span className="span-blue">comandos</span>, <span className="span-blue">parametros opcionales</span> y su <span className="span-blue">orden</span> a utilizar.
            </p>

            <p>
                A <span className="span-pink">continuación</span>, se muestra la <span className="span-white">siguiente imagen</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"2. Comando de ayuda para John the Ripper."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Utilización de John the Ripper.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">John the Ripper</span> trabaja <span className="span-white">principalmente</span> con <span className="span-pink">archivos de hashes</span>. Por <span className="span-pink">ejemplo</span>:
            </p>

            <b >
                <p className="span-blue">
                    1. Simulación y creación de hashes
                </p>
            </b>

            <p>
                Supongamos que obtuvimos un <span className="span-white">archivo hash</span> con el siguiente <span className="span-pink">contenido</span>:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"3. Archivo hash para uso de John the Ripper."}
            />

            <p>
                Si deseas simular el <span className="span-white">archivo</span>, puedes realizarlo, <span className="span-white">ejecutando</span> los siguiente <span className="span-pink">comandos</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'echo -n "password123" | openssl md5 >> hashes.txt'
            />
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'echo -n "admin" | openssl md5 >> hashes.txt'
            />
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'echo -n "letmein" | openssl md5 >> hashes.txt'
            />
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'echo -n "123456" | openssl md5 >> hashes.txt'
            />

            <p>
                <span className="span-pink">Generando</span> de esta manera un <span className="span-white">archivo</span> llamado <i className="span-white">"hashes.txt"</i>, el cual contiene <span className="span-pink">passwords hasheadas</span> por <span className="span-pink">openssl</span> en tipo <span className="span-pink">md5</span>.
            </p>

            <p>
                Despues, para <span className="span-pink">limpiar</span> nuestro <span className="span-white">archivo de hashes</span>, debemos limpiar el formato, <span className="span-pink">eliminando</span> los caracteres siguientes de todos los hashes:
            </p>

            <ul className="ol-code">
                <li>
                    <p className="span-white">
                        md5 (stdin) =
                    </p>
                </li>
            </ul>

            <p>
                Quedando <span className="span-pink">nuestro archivo</span> de la siguiente manera:
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"4. Archivo hash final para uso de John the Ripper."}
            />

            <p>
                Si deseas generar solo el <span className="span-white">archivo final</span>, puedes ejecutar los <span className="span-pink">comandos</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'echo "482c811da5d5b4bc6d497ffa98491e38" >> hashes.txt'
            />
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'echo "21232f297a57a5a743894a0e4a801fc3" >> hashes.txt'
            />
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'echo "0d107d09f5bbe40cade3de5c71e9e9b7" >> hashes.txt'
            />
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'echo "e10adc3949ba59abbe56e057f20f883e" >> hashes.txt'
            />

            <b >
                <p className="span-blue">
                    2. Descifrar hashes
                </p>
            </b>

            <p>
                Una vez colocados nuestros <span className="span-white">hashes</span> los cuales deseamos <span className="span-pink">decifrar</span>, podemos ejecutar el <span className="span-pink">comando</span>:
            </p>

            <p>
                La <span className="span-white">sintaxis</span> del <span className="span-pink">comando</span> es la siguiente:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --format=<tipo-hash> <archivo-hashes>.txt'
            />

            <p>
                Basandonos en nuestro <span className="span-white">archivo de ejemplo</span>, el <span className="span-pink">comando</span> seria:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --format=raw-md5 hashes.txt'
            />

            <p>
                Ejecutando:
            </p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"5. Uso de John the Ripper."}
            />

            <b >
                <p className="span-blue">
                    3. Almacenamiento de hashes descubiertos
                </p>
            </b>

            <p>
                Los <span className="span-pink">hashes descubiertos</span> en <span className="span-yellow">John the Ripper</span>, se almacenan dentro de un <span className="span-white">archivo</span> llamado <i className="span-white">john.pot</i>.
            </p>

            <p>
                Podemos <span className="span-white">consultardo</span>, ejecutando el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'nano ~/.john/john.pot'
            />

            <p>
                Otra manera tambien:
            </p>

            <Img
                img = {Img_Six}
                alt = {"Imagen 6. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"6. Almacenamiento de hashes de John the Ripper."}
            />

            <b >
                <p className="span-blue">
                    4. Encontrar de tipo de hash
                </p>
            </b>

            <p>
                En la vida real, será muy complicado saber en que <span className="span-white">tipo de hashes</span> se encuentran encubiertos nuestras <span className="span-pink">contraseñas</span>, por lo que, para descubrir su <span className="span-white">contenido</span>, primero deberemos descubrir su tipo.
            </p>

            <p>
                Para ello, podemos hacer uso de una pequeña <span className="span-pink">herramienta</span> llamada <span className="span-yellow">hashid</span>:
            </p>

            <p>
                Para <span className="span-pink">instalar</span> la herramienta de <span className="span-yellow">Hashid</span>, utilizamos el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'sudo apt install hashid'
            />

            <p>
                Como se muestra en la <span className="span-pink">imagen</span>:
            </p>

            <Img
                img = {Img_Seven}
                alt = {"Imagen 7. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"7. Instalación de Hashid."}
            />

            <p>
                O bien, <span className="span-pink">descargar</span> su <span className="span-blue">repositorio</span> y <span className="span-blue">ejecutarlo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'git clone https://github.com/psypanda/hashID.git'
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'cd hashID'
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'python3 hashid.py -h'
            />

            <p>
                Para verificar su <span className="span-pink">intalación</span>, puedes utilizar el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'hashid --v'
            />

            <p>
                El cual mostrará la <span className="span-white">version instalada</span> en nuestro <span className="span-pink">sistema</span>.
            </p>

            <p>Como en la siguiente <span className="span-pink">imagen</span>:</p>

            <Img
                img = {Img_Ten}
                alt = {"Imagen 8. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"8. Versión con Hashid."}
            />

            <p>
                Para obtener <span className="span-blue">información</span> y <span className="span-blue">ayuda</span> de la <span className="span-white">herramienta</span> podemos ejecutar el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'hashid --help'
            />

            <p>
                Mostrando:
            </p>

            <Img
                img = {Img_Eight}
                alt = {"Imagen 9. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"9. Ayuda con Hashid."}
            />

            <p>
                Para su uso, se utiliza el <span className="span-pink">comando</span> de la siguiente manera:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'hashid <hash>'
            />

            <p>
                En un <span className="span-white">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'hashid e10adc3949ba59abbe56e057f20f883e'
            />

            <p>
                Donde:
            </p>

            <Img
                img = {Img_Nine}
                alt = {"Imagen 10. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"10. Uso de Hashid."}
            />

            <p>
                Devolviendo los <span className="span-white">posibles tipos de hash</span> los cuales puedan ser <span className="span-pink">utiles</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Utilización de John the Ripper con mayor intensidad.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">John The Ripper</span> permite la configuración sobre la intensidad de un ataque.
            </p>

            <p>
                Para ello, utilizamos el parametro <i className="span-white">--fork</i>.
            </p>

            <p>Como el siguiente comando:</p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --format=<tipo-hash> --fork=<intensidad> <archivo-hashes>.txt'
            />

            <p>
                Ejemplo:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --format=raw-md5 --fork=4 hashes.txt'
            />

            <p>
                <span className="span-yellow">Nota:</span> El rango del <span className="span-white">parametro</span> <i className="span-white">--fork</i> es de <span className="span-pink">1</span> hasta <span className="span-pink">4</span>.
            </p>

            <p>
                Tal como se muestra en la imagen:
            </p>

            <Img
                img = {Img_Eleven}
                alt = {"Imagen 11. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"11. Uso de intensidad con John the Ripper."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Utilización de John the Ripper solo con fuerza bruta.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Entendamos que <span className="span-yellow">John The Ripper</span> utiliza para <span className="span-white">desifrar</span> las <span className="span pink">contraseñas</span> por medio de un <span className="span-white">diccionario por default (puede ser configurado para personalizar)</span>, despues de utilizar este y <span className="span-blue">no encontrar</span> las contraseñas, utilizará el metodo de <span className="span-pink">fuerza bruta</span> para decifrarlas.
            </p>

            <p>
                Con ayuda del <span className="span-pink">parametro</span> <i className="span-white">--incremental</i> podemos ejecutar de <span className="span-pink">manera directa</span> el método de <span className="span-pink">fuerza bruta</span>, omitiendo el metodo de un <span className="span-white">diccionario</span>.
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --incremental --format=<tipo-hash> <archivo-hashes>.txt'
            />

            <p>
                Ejemplo:
            </p>
            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --incremental --format=raw-md5 hashes.txt'
            />

            <p>
                Donde:
            </p>

            <Img
                img = {Img_Twelve}
                alt = {"Imagen 12. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"12. Uso de John the Ripper exclusivo con fuerza bruta."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Restaurar sesiones de John the Ripper.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                En caso de haber <span className="span-pink">interrumpido un ataque</span>, <span className="span-yellow">John the Ripper</span> <span className="span-white">guarda el proceso</span> para ser <span className="span-pink">restaurado</span> en algun <span className="span-blue">futuro</span>.
            </p>

            <p>
                Para <span className="span-white">realizar</span> esto, utilizamos el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --restore'
            />

            <p>
                Ejemplo:
            </p>

            <Img
                img = {Img_Thirteen}
                alt = {"Imagen 13. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"13. Restauración de sesión de John the Ripper exclusivo."}
            />

            <p>
                <span className="span-yellow">Nota:</span> Este <span className="span-white">método</span> puede ser util para <span className="span-pink">largas sesiones</span> de <span className="span-white">encontrar contraseñas</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Utilizar diccionarios personalizados con John the Ripper.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">John the Ripper</span> utiliza un <i className="span-white">diccionario propio</i> para encontrar <span className="span-pink">credenciales</span>, la cual se encuentra en: <i className="span-white">/usr/share/john/password.lst</i>.
            </p>

            <p>
                Podemos <span className="span-pink">consultar</span> su <span className="span-white">contenido</span> con el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'nano /usr/share/john/password.lst'
            />

            <p>
                Pero tambien <span className="span-yellow">John the Ripper</span> nos permite <span className="span-pink">trabajar</span> con <span className="span-white">otros diccionarios</span> que deseemos, con ayuda del <span className="span-pink">parametro</span> <i className="span-white">--wordlist</i>.
            </p>

            <p>
                La <span className="span-pink">sintaxis</span> es:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --wordlist=<url-diccionario> --format=<tipo-hash> <archivo-hashes>.txt'
            />

            <p>
                Ejemplo:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = 'john --wordlist=password.txt --format=raw-md5 hashes.txt'
            />

            <p>
                Veamos:
            </p>

            <Img
                img = {Img_Fourteen}
                alt = {"Imagen 14. JOHN THE RIPPER."}
                title = {"Descripcción de imagen."}
                text = {"14.Uso de diccionario personalizado en John the Ripper."}
            />

            <p>
                <span className="span-yellow">Nota:</span> En el <span className="span-white">ejemplo</span>, tenemos un <span className="span-pink">diccionario personalizado</span> llamado <i className="span-white">password.txt</i>, el cual contiene las <span className="span-pink">contraseñas en texto plano</span> encontradas.
            </p>

            <p>
                <span className="span-yellow">Nota:</span> Recuerda, las <span className="span-white">contraseñas encontradas</span> se almacenan en el <span className="span-pink">archivo</span> <i className="span-white">john.pot</i>, no olvides <span className="span-blue">consultarlas</span>.
            </p>
        </>


    );
}